/**
 * Added because on some phones (probably only Android) top bar overlaps
 * page and position { top: 0 } is under this bar, so we need to compensate
 */
export const MOBILE_SCROLL_TO_SUGGESTIONS_OFFSET = 63

// Addition to animation end, just to compensate possible lags
export const SCROLL_DELAY_MS = 100

export const SUGGESTIONS_CHECK_KEY = 'SUGGESTIONS_WERE_SHOWN_ON_FOCUS'
